<template>
  <div class="already-receive-list">
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="分批申请单号:" prop="deliveryNum">
        <el-input v-model.trim="searchForm.deliveryNum" placeholder="请输入分批申请单号" />
      </el-form-item>
      <el-form-item label="项目名称:" prop="projectName">
        <el-input v-model.trim="searchForm.projectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="发货单号:" prop="erpInvoiceNum">
        <el-input v-model.trim="searchForm.erpInvoiceNum" placeholder="请输入发货单号" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="contractNum">
        <el-input v-model.trim="searchForm.contractNum" placeholder="请输入合同编号" />
      </el-form-item>
      <el-form-item label="代理商名称:" prop="channelName">
        <el-input v-model.trim="searchForm.channelName" placeholder="请输入代理商名称" />
      </el-form-item>
      <el-form-item label="现销/赊销:" prop="salesType">
        <el-select v-model="searchForm.salesType" placeholder="请选择" clearable>
          <el-option v-for="option in salesTypeList" :key="option.name" :label="option.name" :value="option.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="合同类型:" prop="contractType">
        <el-select v-model="searchForm.contractType" placeholder="请选择" clearable>
          <el-option v-for="option in contractType" :key="option.name" :label="option.name" :value="option.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="分配比例:" prop="endDistributionRatio">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-input-number v-model.trim="searchForm.startDistributionRatio" :precision="2" :min="0" :max="100" placeholder="分配比例" :controls="false" />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-input-number v-model.trim="searchForm.endDistributionRatio" :precision="2" :min="0" :max="100" placeholder="分配比例" :controls="false" />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="申请时间:" prop="startTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="部门:" prop="deptName">
        <el-input v-model="searchForm.deptName" placeholder="请输入部门" />
      </el-form-item>
      <el-form-item label="区域:" prop="area">
        <el-input v-model="searchForm.area" placeholder="请输入区域" />
      </el-form-item>
      <el-form-item label="商务:" prop="regionBusinessCommissioner">
        <el-input v-model="searchForm.regionBusinessCommissioner" placeholder="请输入商务名称" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="deliveryNum" label="分批申请单号" align="left" width="150" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="numberClick(row)">
              {{ row.deliveryNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="masterProjectName" label="项目名称" align="left" min-width="220" />
        <el-table-column prop="masterContractNum" label="合同编号" align="left" width="130">
          <template v-slot="{row}">
            <!-- <el-button type="text" @click="contractNumClick(row)">{{ row.masterContractNum }}</el-button> -->
            <span>{{ row.masterContractNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderUnit" label="代理商名称" align="left" min-width="120" />
        <el-table-column prop="contractType" label="订单分类" align="left" width="100" />
        <el-table-column prop="createTime" label="申请时间" align="left" width="150" />
        <el-table-column prop="salesType" label="现销/赊销" align="left" width="90" />
        <el-table-column prop="proportion" label="分配比例" align="right" width="90" header-align="left" />
        <el-table-column prop="processStateStr" label="状态信息" align="left" width="" />
        <el-table-column prop="regionBusinessCommissioner" label="商务" align="left" width="90" />
        <el-table-column prop="invoiceNum" label="发货单号" width="130" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="deliverClick(row)">
              {{ row.invoiceNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="物流单号" width="140" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="logistClick(row)">
              {{ row.logisticsNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="proportion" label="操作" align="left" width="80" fixed="right">
          <template v-slot="{row}">
            <el-button v-if="row.processStateStr !== '订单员驳回'&&row.processStateStr !== '撤销废弃' " type="text" @click="revoke(row)">
              撤销
            </el-button>
            <!-- <el-button type="text" @click="revoke(row)">撤销</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <el-dialog
      title="撤销原因"
      :visible.sync="dialogVisible"
      width="360px"
      @close="revokeDialogClose"
    >
      <el-input
        v-model="deleteReason"
        type="textarea"
        placeholder="请输入撤销原因"
        maxlength="200"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <!-- <el-button size="mini" type="text" @click="dialogVisible = false">取消</el-button> -->
        <el-button type="primary" size="mini" :loading="revockLoading" @click="handleDeleteDebit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="发货产品清单" :visible.sync="receiptProductVisible" width="800px">
      <delivery-receipt-product-list v-if="receiptProductVisible" :receipt-number="receiptNumber" />
    </el-dialog>
    <el-dialog title="回单信息" :visible.sync="receiptVisible" width="700px">
      <receipt-list v-if="receiptVisible" :receipt-form="receiptForm" :is-show="isShow" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="receiptVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <partShipCheck :id="partId" :dialog-form-visible="dialogFormVisible" @on-status-dialog="updataDialogFormVisible" />
    <deliverGoodsNumber :dialog-form-visible-deliver="dialogFormVisibleDeliver" :form="formNum" @on-status-dialog="updataDialogFormVisibleDeliver" />
    <logisticsNumber :dialog-form-visible-logist="dialogFormVisibleLogist" :form="formNum" @on-status-dialog="updataDialogFormVisibleLogist" />
  </div>
</template>

<script>
// import { getOrdersContractList } from '@/API/index.js';
import { approvedPartialInvoice, undoPartialInvoice } from '@/API/index.js';
import partShipCheck from '../../partShipCheck';
import deliverGoodsNumber from '../../partShipCheck/deliverGoodsNumber';
import logisticsNumber from '../../partShipCheck/logisticsNumber';
import eventBus from '@/libs/eventBus.js';
import { mapState } from 'vuex';
export default {
  name: 'AlreadyReceiveList',
  data () {
    return {
      tableLoading: false,
      receiptProductVisible: false,
      // 定义组件
      dialogFormVisible: false,
      dialogFormVisibleDeliver: false,
      dialogFormVisibleLogist: false,
      partId: '',
      formNum: {},
      searchForm: {
        type: 'APPROVED',
        deliveryNum: '',
        projectName: '',
        erpInvoiceNum: '',
        contractNum: '',
        channelName: '',
        startTime: '',
        endTime: '',
        deptName: '',
        area: '',
        salesType: '0',
        contractType: '',
        startDistributionRatio: '',
        endDistributionRatio: '100',
        regionBusinessCommissioner: ''
      },
      tableData: [],
      revockLoading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100
      },
      receiptNumber: '',
      receiptVisible: false,
      receiptForm: {},
      isShow: false,
      // 撤销参数
      dialogVisible: false,
      deleteReason: '',
      revokedata: {}
    };
  },
  components: {
    partShipCheck,
    deliverGoodsNumber,
    logisticsNumber
  },
  computed: {
    ...mapState({
      salesTypeList: state => state.enumeration.salesTypeList, //  现销/赊销
      contractType: state => state.enumeration.contractType
    })
  },
  methods: {
    initData () {
      this.tableLoading = true;
      approvedPartialInvoice({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.tableData.forEach((item) => {
            this.$set(item, 'textarea', '');
          });
          this.page.total = json.data.total;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    resetForm () {
      this.$refs['searchForm'].resetFields();
      this.searchForm.endTime = '';
      this.page.currentPage = 1;
      this.initData();
    },
    // 搜索
    doSearch () {
      this.page.currentPage = 1;
      this.initData();
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = '实际结算金额';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = '未发货数量';
        }
      });
      return sums;
    },
    // 合同跳转
    contractNumClick (row) {
      // this.$router.push({ name: 'orderPersionContractInfo', params: { contractNum: row.masterContractNum }, query: { isdisabled: true } });
      // this.$router.push({ name: 'orderPersionContractInfo', params: { contractNum: row.masterContractNum, isdisabled: true } });
      this.$router.push({ name: 'orderPersionContractInfo', params: { contractNum: row.masterContractNum }, query: { id: row.id, isdisabled: true } });
    },

    handerSizeChange () {
      this.page.currentPage = 1;
      this.initData();
    },
    handerCurrentChange () {
      this.initData();
    },
    pickerOptions () {

    },
    numberClick (row) {
      this.partId = row.id;
      this.dialogFormVisible = true;
    },
    deliverClick (row) {
      this.formNum = row;
      this.dialogFormVisibleDeliver = true;
    },
    logistClick (row) {
      this.formNum = row;
      this.dialogFormVisibleLogist = true;
    },
    revokeDialogClose () {
      this.deleteReason = '';
    },
    // 撤销接口
    revoke (row) {
      this.revokedata = row;
      this.dialogVisible = true;
    },
    handleDeleteDebit () {
      let row = this.revokedata;
      if (this.deleteReason === '') {
        this.$message.error('请输入撤销原因');
        return;
      }
      // 调用接口
      this.revockLoading = true;
      undoPartialInvoice({
        'contractNum': row.masterContractNum,
        'partialId': row.id,
        'approveComment': this.deleteReason
      }).then((res) => {
        this.revockLoading = false;

        let json = res.data;
        // this.$refs.gridTable.doClose();
        if (json.status === '200') {
          this.$message({
            type: 'success',
            message: '撤销成功 !'
          });
          this.dialogVisible = false;
          this.initData();
        }
      }).catch(() => {
        this.revockLoading = false;
      });
    },
    // 组件事件
    updataDialogFormVisible (val) {
      this.dialogFormVisible = val;
    },
    // 组件事件
    updataDialogFormVisibleDeliver (val) {
      this.dialogFormVisibleDeliver = val;
    },
    // 组件事件
    updataDialogFormVisibleLogist (val) {
      this.dialogFormVisibleLogist = val;
    }
  },
  mounted () {
    this.initData();
    eventBus.$on('changescom', () => {
      this.initData();
    });
  }
};
</script>

<style scoped>

</style>
